export interface CommitmentResponse {
    /**
     * @remarks Scheduled Callback Id
     */
    callbackId: number;
    /**
     * @remarks "A" if targeted to an Agent or "S" if targeted to a skill
     */
    target: string;
    /**
     * @remarks Agent Id. For Type "S" callbacks set with Max, the agent id will be the agent that schedules callback. 
     * For Type "S" callbacks set with Thin Agent, the agent id will return "-1".
     */
    agentId: number;
    /**
     * @remarks Outbound Skill Id to be used for callback
     */
    skillId: number;
    /**
     * @remarks Phone number to be dialed by Agent
     */
    dialNumber: string;
    /**
     * @remarks Phone number from which the Scheduled Callback originated
     */
    origNumber: string;
    /**
     * @remarks First name of Agent callback is targeted to
     */
    firstName: string;
    /**
     * @remarks Last name of Agent callback is targeted to
     */
    lastName: string;
    /**
     * @remarks Any notes entered into the Scheduled Callback
     */
    notes: string;
    /**
     * @remarks ISO 8601 time requested for Scheduled Callback
     */
    callbackTime: Date;
  }